import { FlamingoTypes } from '@mode/shared/contract-common';

export abstract class SwitchAttrsFacade {
  abstract createSwitchAttr(attr: FlamingoTypes.ModeCalc, token: string): void;
  abstract createSwitchAttrFromDataView(attr: FlamingoTypes.ModeCalc, token: string): void;
  abstract updateSwitchAttr(
    attr: FlamingoTypes.ModeCalc,
    token: string,
    prevAttr: FlamingoTypes.ModeCalc,
    queryToken: string
  ): void;
  abstract updateSwitchAttrFromDataView(
    attr: FlamingoTypes.ModeCalc,
    token: string,
    prevAttr: FlamingoTypes.ModeCalc,
    queryToken: string
  ): void;
  abstract deleteSwitchAttr(attr: FlamingoTypes.ModeCalc, token: string, queryToken: string): void;
  abstract makeOriginalAttrs(): void;
  abstract restoreOriginalAttrs(): void;
}
